import { useField } from "formik";
import React, { useRef, useState } from "react";
import {
	Button,
	Icon,
	Input,
	Message,
	Modal,
	Segment,
} from "semantic-ui-react";
import Alerts from "utilities/Alerts";
import http from "utilities/http";

function InvoiceUpload({ open, closeModal, proceed }) {
	let inputField = useRef(null);
	const [image, setImage] = useState(null);

	const [{ value: invoiceNo }, ,] = useField("invoiceNo");

	const uploadInvoice = async () => {
		try {
			if (!image) return;
			const uploadForm = new FormData();
			uploadForm.append("invoiceNo", invoiceNo);
			uploadForm.append("photo", image);
			await http.post("/stock/purchase/invoice/upload", uploadForm);

			closeModal();
			proceed();
		} catch (ex) {
			Alerts.httpException(ex);
		}
	};

	return (
		<Modal open={open} size="tiny">
			<Modal.Content>
				<Segment textAlign="center" padded="very">
					<p style={{ fontSize: "18px" }}>
						<b>Do you want to upload an image for the invoice?</b>
					</p>
					<Input
						ref={inputField}
						type="file"
						placeholder="Upload"
						accept="image/png, image/webp, image/jpeg"
						style={{ display: "none" }}
						onChange={(e) => setImage(e.target.files[0])}
					/>
					<Button
						secondary
						onClick={() => {
							console.log({ inputField });
							inputField.current.inputRef.current.click();
						}}
					>
						Choose Image
					</Button>
					{image ? (
						<Segment basic>
							<Message>
								<p>{image.name}</p>
								<Button onClick={uploadInvoice} positive>
									Upload
								</Button>
							</Message>
						</Segment>
					) : null}
				</Segment>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={closeModal} basic secondary>
					Cancel
				</Button>
				<Button onClick={proceed} color="blue">
					No, thanks. <Icon name="arrow right" />
				</Button>
			</Modal.Actions>
		</Modal>
	);
}

export default InvoiceUpload;
